
import { storage } from '../lib/storage';
import { Influencer, Order } from '../types';

export const influencerService = {
  getStoreInfluencers: (storeId: string): Influencer[] => {
    return storage.getInfluencers(storeId);
  },

  addInfluencer: (storeId: string, name: string, handle: string, commissionRate: number) => {
    const newInfluencer: Influencer = {
      id: 'inf-' + Date.now() + '-' + Math.random().toString(36).substr(2, 5),
      storeId,
      name,
      handle,
      commissionRate,
      totalSalesGenerated: 0,
      totalCommissionEarned: 0,
      isActive: true,
      onboardedAt: new Date().toISOString()
    };
    storage.saveInfluencer(newInfluencer);
    return newInfluencer;
  },

  getInfluencerById: (id: string): Influencer | null => {
    const allStores = storage.getStores();
    for (const store of allStores) {
      const found = storage.getInfluencers(store.id).find(i => i.id === id);
      if (found) return found;
    }
    return null;
  },

  trackConversion: (influencerId: string, orderAmount: number) => {
    const influencer = influencerService.getInfluencerById(influencerId);
    if (!influencer) return;

    const commission = (orderAmount * influencer.commissionRate) / 100;
    
    influencer.totalSalesGenerated += orderAmount;
    influencer.totalCommissionEarned += commission;
    
    storage.saveInfluencer(influencer);
    return commission;
  }
};
